/**
 * pixi-particles — ParticleBounds.ts
 * Ported from Phaser.GameObjects.Particles.ParticleBounds
 *
 * Defines a rectangular region, in world space, within which particle
 * movement is constrained. Particles rebound off any active edge
 * (`collideLeft/Right/Top/Bottom`), scaled by the particle's `bounce` value.
 */
import { ParticleProcessor } from './ParticleProcessor';
import { AnyParticle } from './EmitterOp';

export class ParticleBounds extends ParticleProcessor
{
    bounds: { x: number; y: number; width: number; height: number; right: number; bottom: number };

    collideLeft: boolean;
    collideRight: boolean;
    collideTop: boolean;
    collideBottom: boolean;

    constructor (
        x: number, y: number, width: number, height: number,
        collideLeft = true, collideRight = true, collideTop = true, collideBottom = true
    )
    {
        super(x, y, true);

        this.bounds = { x, y, width, height, right: x + width, bottom: y + height };

        this.collideLeft = collideLeft;
        this.collideRight = collideRight;
        this.collideTop = collideTop;
        this.collideBottom = collideBottom;
    }

    override update (particle: AnyParticle): void
    {
        var bounds = this.bounds;
        var bounce = -particle.bounce;
        var pos = particle.worldPosition;

        if (pos.x < bounds.x && this.collideLeft)
        {
            particle.x += bounds.x - pos.x;
            particle.velocityX *= bounce;
        }
        else if (pos.x > bounds.right && this.collideRight)
        {
            particle.x -= pos.x - bounds.right;
            particle.velocityX *= bounce;
        }

        if (pos.y < bounds.y && this.collideTop)
        {
            particle.y += bounds.y - pos.y;
            particle.velocityY *= bounce;
        }
        else if (pos.y > bounds.bottom && this.collideBottom)
        {
            particle.y -= pos.y - bounds.bottom;
            particle.velocityY *= bounce;
        }
    }
}

export default ParticleBounds;
